import { render, staticRenderFns } from "./ReFromMetro.vue?vue&type=template&id=08300549&scoped=true"
import script from "./ReFromMetro.vue?vue&type=script&lang=js"
export * from "./ReFromMetro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08300549",
  null
  
)

export default component.exports